import { PAGES } from '@/constants/pages';

export const NAVIGATION_KEYS = {
  '/D': PAGES.DASHBOARD,
  '/R': PAGES.REPORTS,
  '/S': PAGES.SEGMENTS,
} as const;
